import { Typography } from '@mui/material';

import { TableCellCustom } from '@app/components/table';
import { TruncatedTypography } from '@app/components';
import { RowActions } from './row-actions';
import { ITestimonial } from '../types';

interface Props {
  row?: ITestimonial;
  selected: boolean;
  onSelectRow: VoidFunction;
  canAddTestimonial?: string;
}

const TestimonialRow = (props: Props) => {
  const { row, canAddTestimonial } = props;

  return (
    <>
      <TableCellCustom align="center">
        <Typography variant="body2">{row?.clientId}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <Typography variant="body2">
          {row?.client?.firstName} {row?.client?.lastName}
        </Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <Typography variant="body2">{row?.projectName}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <TruncatedTypography variant="body2" text={row?.feedback} />
      </TableCellCustom>
      {canAddTestimonial ? (
        <TableCellCustom align="right" width={50}>
          <RowActions row={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { TestimonialRow };
